import { useState } from "react";
import type { MenuType } from "../ListItems";

export const useWorkflowMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuTriggerElement, setMenuTriggerElement] =
    useState<null | HTMLElement>(null);
  const [selectedWorkflow, setSelectedWorkflow] = useState<MenuType | null>(
    null
  );

  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    workflow: MenuType
  ) => {
    setMenuTriggerElement(event.currentTarget);
    setSelectedWorkflow(workflow);
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  // メニューが閉じられたらトリガー要素と選択ワークフローをクリア
  const handleOpenChange = (open: boolean) => {
    setMenuOpen(open);
    if (!open) {
      setTimeout(() => {
        setMenuTriggerElement(null);
        setSelectedWorkflow(null);
      }, 100);
    }
  };

  return {
    menuOpen,
    setMenuOpen: handleOpenChange,
    menuTriggerElement,
    selectedWorkflow,
    handleMenuClick,
    handleMenuClose,
  };
};
